// כרטיסי KPI (09 §1): ערך, שינוי (סימן + חץ + צבע — לא צבע לבד; good:'down' = ירידה טובה), קו מגמה (spark).
// אותו מראה כמו ab.kpis ב-iframe (kit/controls.js, kit/kit.css).
import { BlockHead } from './Expand.tsx';
import type { KpiBlock as KpiBlockT } from '@aibify/core';
import { fmtCell } from './format.ts';
import { sparkPath } from './kit/series.js';
import { deltaTone } from './kit/controls.js';

const nf = new Intl.NumberFormat('he-IL', { maximumFractionDigits: 1, signDisplay: 'exceptZero' });

function Spark({ values, tone }: { values: (number | null)[]; tone: string }) {
  return (
    <svg className={`ab-spark ab-kpi-spark ${tone}`} viewBox="0 0 100 28" preserveAspectRatio="none" aria-hidden="true" data-testid="kpi-spark">
      <path d={sparkPath(values, 100, 28, 3)} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />
    </svg>
  );
}

export function KpiBlock({ block }: { block: KpiBlockT }) {
  return (
    <section className="ab-block" data-block-type="kpi" data-block-id={block.id}>
      <BlockHead titleHe={block.titleHe} />
      <div className="ab-kpis">
        {block.cards.map((c, i) => {
          const d = c.delta ?? null;
          const tone = deltaTone(d, c.good);
          const spark = c.spark && c.spark.length > 1 ? c.spark : null;
          return (
            <div key={i} className="ab-kpi" data-testid="kpi-card">
              <div className="ab-kpi-label">{c.labelHe}</div>
              <div className="ab-kpi-value">
                <bdi dir="auto">{fmtCell(c.value, c.type)}</bdi>
              </div>
              {(d !== null || spark) && (
                <div className="ab-kpi-foot">
                  {d !== null && (
                    <div className={`ab-kpi-delta ${tone}`}>
                      <span aria-hidden="true">{d > 0 ? '▲' : d < 0 ? '▼' : '•'}</span> <bdi dir="ltr">{nf.format(d * 100)}%</bdi>
                    </div>
                  )}
                  {spark && <Spark values={spark} tone={tone} />}
                </div>
              )}
              {c.hintHe && <div className="ab-kpi-hint">{c.hintHe}</div>}
            </div>
          );
        })}
      </div>
    </section>
  );
}
